import React, { useContext, useEffect, useState } from 'react'
import { flowRight } from 'lodash'
import { withTranslationCustom } from 'lib/i18next'
import { isLoggedIn, graphqlCurrentUserCached } from 'lib/utils/store/currentUser'
import { AddToHomePromptContext } from './AddToHomePrompt'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'

import AppContext from 'components/AppContext'
import Button from 'components/UI/Button'
import Icon from 'components/Icon'

import './add-to-home.pcss'

const AddToHome = ({ t, currentUser }) => {
    const { prompt, promptToInstall } = useContext(AddToHomePromptContext)
    const [isVisible, setVisibleState] = useState(false)

    const hide = () => setVisibleState(false)

    useEffect(() => {
        if (prompt && isLoggedIn(currentUser)) {
            setVisibleState(true)
        } else {
            setVisibleState(false)
        }
    }, [prompt, currentUser])

    if (!isVisible) {
        return null
    }

    return (
        <AppContext context="addToHome">
            <div className="add-to-home">
                <div className="add-to-home__icon">
                    <img src="/images/favicon-196x196.png" alt="icon" />
                </div>
                <div className="add-to-home__actions">
                    <Button
                        trackName="addToHome"
                        className="add-to-home__button"
                        onClick={promptToInstall}
                    >
                        {t('common:addToHome')}
                    </Button>
                    <Button
                        trackName="close"
                        className="add-to-home__button add-to-home__button--close"
                        onClick={hide}
                    >
                        <Icon name="icon_x_gray" size="m" />
                    </Button>
                </div>
            </div>
        </AppContext>
    )
}

export default flowRight(
    withTranslationCustom(),
    graphqlCurrentUserCached,
    withErrorBoundaryNoRender,
)(AddToHome)
